import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { isEmpty } from "lodash-es";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "@/store";
import { parmsFromat } from "@/utils/toolt";

export default function NavigateRedirect({ path }: any) {
  const menus = useAppSelector((state) => state.app.menus);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const currentPath = menus?.routes?.find((item) => item.path === pathname);
    if (
      pathname === path &&
      currentPath?.routes &&
      !isEmpty(currentPath.routes)
    ) {
      const { path, defaultParams } = currentPath.routes[0];
      navigate(parmsFromat(defaultParams, path), { replace: true });
    }
  }, [path, navigate, pathname, menus]);
  return <Outlet />;
}
